// Rebasing a queued edit onto the revs the room has answered since. Pure, out
// of useJamEditor so the extension's jam fuzzer (extension/test/fuzz/) sends
// a web edit exactly as the page does.

import type { Intent } from "@shared/sync/intents.js";

/**
 * Edits to one clip go out one at a time, each citing the rev the room gave
 * the one before: two quick taps on Pitch "+" used to race, the second
 * built against the first's pre-flight rev and refused as stale, so the
 * sound went +1, +2, back to +1 (playback-audit §2.2). The intents are
 * built from the PROJECTED room (the first tap's +1 already in), so only
 * their `baseRev` is behind — `knownRevs` holds what the room has answered
 * since, and a cited rev older than that is moved up to it.
 */
export function rebaseIntents(intents: readonly Intent[], knownRevs: ReadonlyMap<string, number>): Intent[] {
  return intents.map((intent) => {
    if ((intent.kind !== "upsertClip" && intent.kind !== "deleteClip") || intent.id === null) return intent;
    const known = knownRevs.get(intent.id);
    if (known === undefined || intent.baseRev === null || known <= intent.baseRev) return intent;
    return { ...intent, baseRev: known };
  });
}
